<template>
    <div class="my-set-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="clickBack"></title-bar>

        <!-- 2. 设置列表 -->
        <div class="my-set-list">
            <div class="my-set-item" @click="clickSetTel">
                <span class="my-set-item-title">修改手机号</span>
                <span class="my-set-item-icon"><i class="iconfont icon-xiangyou"></i></span>
            </div>
            <div class="my-set-item" @click="clickSetPwd">
                <span class="my-set-item-title">修改密码</span>
                <span class="my-set-item-icon"><i class="iconfont icon-xiangyou"></i></span>
            </div>
            <div class="my-set-item" @click="clickSetMyUI">
                <span class="my-set-item-title">命盘显示设置</span>
                <span class="my-set-item-icon"><i class="iconfont icon-xiangyou"></i></span>
            </div>
        </div>
        <!-- 3. 退出登录按钮 -->
        <!-- <div class="my-set-logout" @click="clickLogout">退出登录</div> -->
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
export default {
    name: 'MySet',
    components: { TitleBar },
    data() {
        return {
            titleData: {'titleText': '设置', 'showCancel': false},
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
        },
        clickBack() {
            this.$router.replace('/my');
        },
        clickSetTel() {
            this.$router.replace('/my/settel');
        },
        clickSetPwd() {
            this.$router.replace('/my/setpwd');
        },
        clickLogout() {
            // console.error('clickLogout');
        },
        clickSetMyUI() {
            this.$router.push({
                path: '/my/setui'
            });
        }
    }
}
</script>